import { TraitRegistry, TraitType } from '../../trait-registry';
import { Trait } from '../../trait.type';
import { DieFace } from '../../face.type';
import type { Technique } from '../../techniques.type';
import type { Player } from '../../player.type';
import type { Song } from '../../status-effects/song';
import { StatusEffect } from '../../status-effects.type';

export class PiperTrait extends Trait {
  static baseType = TraitType.Piper;
  static baseTitle = 'Piper';
  static baseText =
    'When using a technique that contains the blowgun, apply the effect of the current song once per turn.';
  static baseIcon = 'trait';

  type = PiperTrait.baseType;
  title = PiperTrait.baseTitle;
  text = PiperTrait.baseText;
  icon = PiperTrait.baseIcon;

  useTechnique(technique: Technique, target: Player, source: Player): void {
    if (technique.ingredients.includes(DieFace.Blowgun)) {
      let song = source.statusEffects.find(
        (modifier) => modifier.type === StatusEffect.Song,
      ) as Song;
      if (song) {
        song.activate();
      }
      if (target === source) return;
      song = target.statusEffects.find((modifier) => modifier.type === StatusEffect.Song) as Song;
      if (song) {
        song.activate();
      }
    }
  }
}

TraitRegistry.register(PiperTrait.baseType, PiperTrait);
